import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';

class SubscriptionSuccess extends Component {
    render() {
        const LastBillingDate = this.props.subscriptionDetails.getIn([
            'contract',
            'LastBillingDate',
        ]);
        const NextBillingDate = this.props.subscriptionDetails.getIn([
            'contract',
            'NextBillingDate',
        ]);
        const PaymentProvider = this.props.subscriptionDetails.getIn([
            'contract',
            'PaymentProvider',
        ]);
        const validMembers = this.props.subscriptionDetails
            .get('members')
            .filter(member => member.get('email') !== '' && member.get('email') !== null);
        return (
            <Paper style={{ padding: '20px' }}>
                <h2>Software-Abos erfolgreich bestellt!</h2>
                <p>
                    Folgende Empfänger erhalten in Kürze eine E-Mail mit Software-Abo-Informationen:
                </p>
                <ul>
                    {validMembers.map(member => (
                        <li key={member.get('email')}>{member.get('email')}</li>
                    ))}
                </ul>
                <br />
                <p>
                    {' '}
                    Sie erhalten die 1. Rechnung per E-Mail am{' '}
                    {moment(LastBillingDate).format('DD.MM.YYYY')}.{' '}
                </p>
                <RaisedButton
                    primary={true}
                    label="Zur Software-Abo Übersicht"
                    onClick={this.props.navigateToList}
                />
                {/*<span>Erste Rechnung: { moment(LastBillingDate).format('DD.MM.YYYY') }</span>*/}
                {/*<br/>*/}
                {/*<span>Nächste Rechnung: { moment(NextBillingDate).format('DD.MM.YYYY') }</span>*/}
            </Paper>
        );
    }
}

export default SubscriptionSuccess;
